import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CustomValidator, fromToDate } from '../../../../../../../common/forms/custom.validators';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  VehicleAppEntityVehicleWrite
} from '../../../../../../../openapi';
import { VehicleForm } from './vehicle-form';

@Injectable()
export class PermitForOversizeVehicleTravelDataForm extends AppForm {
  constructor() {
    super({
      startDate: new FormControl(null, { validators: [Validators.required, CustomValidator.isValidDateFormat(), CustomValidator.minDate(new Date())] }),
      endDate: new FormControl(null, { validators: [Validators.required, CustomValidator.isValidDateFormat()] })
    }, {
      validators: [
        fromToDate('startDate', 'endDate')
      ]
    });
  }

  public get startDate(): FormControl {
    return this.get('startDate') as FormControl;
  }

  public get endDate(): FormControl {
    return this.get('endDate') as FormControl;
  }

  public get vehicleForm(): VehicleForm | null {
    return this.get('vehicleForm') as VehicleForm | null;
  }

  public get vehicleValues(): VehicleAppEntityVehicleWrite[] {
    return this.vehicleForm?.value ? [this.vehicleForm.value] : [];
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    const value = this.value;
    delete value.vehicles;
    return value;
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead) {
    if (value?.applicationSubject === 'Kategorii I') {
      this.addControl('vehicleForm', new VehicleForm());
    }
    this.vehicleForm?.patchFormValues(value?.vehicles?.at(0))
    super.patchFormValues(value);
  }
}
